module.exports = __webpack_public_path__ + "img/NoDataStateIcon.45ef7c1.svg";